import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { StyledTooltip, TooltipText } from './styles'

const Tooltip = (props) => {
  const { text, children, style, textPosition } = props
  const [hovered, setHovered] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({})
  const parentRef = useRef(null)
  const tooltipRef = useRef(null)

  useEffect(() => {
    if (hovered && parentRef.current && tooltipRef.current) {
      const rect = parentRef.current.getBoundingClientRect()
      const tooltipRect = tooltipRef.current.getBoundingClientRect()
      const tooltipPos = calculateTooltipPosition(
        rect,
        tooltipRect,
        textPosition
      )
      // Set calculated position and visibility of tooltip
      setTooltipPosition({ ...tooltipPos, visibility: 'visible', opacity: 1 })
    } else {
      setTooltipPosition({})
    }
  }, [hovered, textPosition])

  const calculateTooltipPosition = (parentRect, tooltipRect, position) => {
    const positions = {
      top: {
        top: parentRect.top - tooltipRect.height - 10,
        left: parentRect.left + parentRect.width / 2 - tooltipRect.width / 2,
      },
      right: {
        top: parentRect.top + parentRect.height / 2 - tooltipRect.height / 2,
        left: parentRect.right + 10,
      },
      bottom: {
        top: parentRect.bottom + 10,
        left: parentRect.left + parentRect.width / 2 - tooltipRect.width / 2,
      },
      left: {
        top: parentRect.top + parentRect.height / 2 - tooltipRect.height / 2,
        left: parentRect.left - tooltipRect.width - 10,
      },
    }

    const pos = positions[position]
    // Boundary checks
    if (pos.top < 0) pos.top = 10
    if (pos.left < 0) pos.left = 10
    if (pos.left + tooltipRect.width > window.innerWidth)
      pos.left = window.innerWidth - tooltipRect.width - 10
    if (pos.top + tooltipRect.height > window.innerHeight)
      pos.top = window.innerHeight - tooltipRect.height - 10

    return pos
  }

  return (
    <StyledTooltip
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      ref={parentRef}
      style={style}
    >
      {children}
      {ReactDOM.createPortal(
        <TooltipText ref={tooltipRef} style={tooltipPosition}>
          {text}
        </TooltipText>,
        document.body
      )}
    </StyledTooltip>
  )
}

Tooltip.defaultProps = {
  style: {},
  text: '',
  textPosition: 'top',
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  textPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  style: PropTypes.object,
  text: PropTypes.string,
}

export default Tooltip
